export const DeleteIcon = ({ color = "#545F71" }) => {
  return (
    <svg
      width="38"
      height="52"
      viewBox="0 0 38 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 33.5C14.0417 33.5 13.6493 33.3368 13.3229 33.0104C12.9965 32.684 12.8333 32.2917 12.8333 31.8333V21H12V19.3333H16.1667V18.5H21.1667V19.3333H25.3333V21H24.5V31.8333C24.5 32.2917 24.3368 32.684 24.0104 33.0104C23.684 33.3368 23.2917 33.5 22.8333 33.5H14.5ZM22.8333 21H14.5V31.8333H22.8333V21ZM16.1667 30.1667H17.8333V22.6667H16.1667V30.1667ZM19.5 30.1667H21.1667V22.6667H19.5V30.1667Z"
        fill={color}
      />
    </svg>
  );
};

export const Drag = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#1f1f1f"
    >
      <path d="M360-160q-33 0-56.5-23.5T280-240q0-33 23.5-56.5T360-320q33 0 56.5 23.5T440-240q0 33-23.5 56.5T360-160Zm240 0q-33 0-56.5-23.5T520-240q0-33 23.5-56.5T600-320q33 0 56.5 23.5T680-240q0 33-23.5 56.5T600-160ZM360-400q-33 0-56.5-23.5T280-480q0-33 23.5-56.5T360-560q33 0 56.5 23.5T440-480q0 33-23.5 56.5T360-400Zm240 0q-33 0-56.5-23.5T520-480q0-33 23.5-56.5T600-560q33 0 56.5 23.5T680-480q0 33-23.5 56.5T600-400ZM360-640q-33 0-56.5-23.5T280-720q0-33 23.5-56.5T360-800q33 0 56.5 23.5T440-720q0 33-23.5 56.5T360-640Zm240 0q-33 0-56.5-23.5T520-720q0-33 23.5-56.5T600-800q33 0 56.5 23.5T680-720q0 33-23.5 56.5T600-640Z" />
    </svg>
  );
};

export const Delete = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="delete">
        <mask
          id="mask0_7072_9931"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect id="Bounding box" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_7072_9931)">
          <path
            id="delete_2"
            d="M7.6155 20.0002C7.168 20.0002 6.78683 19.8429 6.472 19.5282C6.15733 19.2134 6 18.8322 6 18.3847V6.00021H5V5.00021H9V4.23096H15V5.00021H19V6.00021H18V18.3847C18 18.845 17.8458 19.2294 17.5375 19.5377C17.2292 19.846 16.8448 20.0002 16.3845 20.0002H7.6155ZM17 6.00021H7V18.3847C7 18.5642 7.05767 18.7117 7.173 18.8272C7.2885 18.9425 7.436 19.0002 7.6155 19.0002H16.3845C16.5385 19.0002 16.6796 18.9361 16.8077 18.808C16.9359 18.6798 17 18.5387 17 18.3847V6.00021ZM9.80775 17.0002H10.8078V8.00021H9.80775V17.0002ZM13.1923 17.0002H14.1923V8.00021H13.1923V17.0002Z"
            fill="#080425"
          />
        </g>
      </g>
    </svg>
  );
};

export const GarbageCanIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5511_5146"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="36"
        height="36"
      >
        <rect width="36" height="36" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5511_5146)">
        <path
          d="M7.6155 20.0002C7.168 20.0002 6.78683 19.8429 6.472 19.5282C6.15733 19.2134 6 18.8322 6 18.3847V6.00021H5V5.00021H9V4.23096H15V5.00021H19V6.00021H18V18.3847C18 18.845 17.8458 19.2294 17.5375 19.5377C17.2292 19.846 16.8448 20.0002 16.3845 20.0002H7.6155ZM17 6.00021H7V18.3847C7 18.5642 7.05767 18.7117 7.173 18.8272C7.2885 18.9425 7.436 19.0002 7.6155 19.0002H16.3845C16.5385 19.0002 16.6796 18.9361 16.8077 18.808C16.9359 18.6798 17 18.5387 17 18.3847V6.00021ZM9.80775 17.0002H10.8078V8.00021H9.80775V17.0002ZM13.1923 17.0002H14.1923V8.00021H13.1923V17.0002Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const DelIcon = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.6155 16C2.168 16 1.78683 15.8426 1.472 15.528C1.15733 15.2131 1 14.832 1 14.3845V1.99996H0V0.999963H4V0.230713H10V0.999963H14V1.99996H13V14.3845C13 14.8448 12.8458 15.2291 12.5375 15.5375C12.2292 15.8458 11.8448 16 11.3845 16H2.6155ZM12 1.99996H2V14.3845C2 14.564 2.05767 14.7115 2.173 14.827C2.2885 14.9423 2.436 15 2.6155 15H11.3845C11.5385 15 11.6796 14.9359 11.8077 14.8077C11.9359 14.6795 12 14.5385 12 14.3845V1.99996ZM4.80775 13H5.80775V3.99996H4.80775V13ZM8.19225 13H9.19225V3.99996H8.19225V13Z"
        fill="#080425"
      />
    </svg>
  );
};

export const DashboardIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4442_12987"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4442_12987)">
        <path
          d="M4 11V4H11V11H4ZM4 20V13H11V20H4ZM13 11V4H20V11H13ZM13 20V13H20V20H13ZM5 10H10V5H5V10ZM14 10H19V5H14V10ZM14 19H19V14H14V19ZM5 19H10V14H5V19Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const BuildingIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4442_12992"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4442_12992)">
        <path
          d="M2.73096 20.1538V3.15375H11.731V7.15375H21.2695V20.1538H2.73096ZM3.73096 19.1538H10.731V16.1538H3.73096V19.1538ZM3.73096 15.1538H10.731V12.1538H3.73096V15.1538ZM3.73096 11.1538H10.731V8.15375H3.73096V11.1538ZM3.73096 7.15375H10.731V4.15375H3.73096V7.15375ZM11.731 19.1538H20.2695V8.15375H11.731V19.1538ZM14.1157 12.1538V11.1538H17.5002V12.1538H14.1157ZM14.1157 16.1538V15.1538H17.5002V16.1538H14.1157Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const ProjectsIcon = ({ size = 24, color = "#080425", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24" // Original coordinate system
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_4442_12999"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4442_12999)">
      <path
        d="M16.1115 20L15.423 19.3115L16.998 17.7115L15.423 16.1365L16.1115 15.423L17.7115 17.023L19.2865 15.423L20 16.1365L18.4 17.7115L20 19.3115L19.2865 20L17.7115 18.425L16.1115 20ZM6.5 19C6.9115 19 7.26442 18.8529 7.55875 18.5587C7.85292 18.2644 8 17.9115 8 17.5C8 17.0885 7.85292 16.7356 7.55875 16.4413C7.26442 16.1471 6.9115 16 6.5 16C6.0885 16 5.73558 16.1471 5.44125 16.4413C5.14708 16.7356 5 17.0885 5 17.5C5 17.9115 5.14708 18.2644 5.44125 18.5587C5.73558 18.8529 6.0885 19 6.5 19ZM6.5 20C5.80767 20 5.21792 19.7564 4.73075 19.2693C4.24358 18.7821 4 18.1923 4 17.5C4 16.8077 4.24358 16.2179 4.73075 15.7308C5.21792 15.2436 5.80767 15 6.5 15C7.091 15 7.615 15.1837 8.072 15.551C8.52917 15.9183 8.81667 16.3937 8.9345 16.977C9.71283 16.909 10.367 16.5891 10.897 16.0173C11.4272 15.4454 11.6923 14.773 11.6923 14V10.2885C11.6923 9.04617 12.1317 7.98558 13.0105 7.10675C13.8893 6.22792 14.9499 5.7885 16.1923 5.7885H18.073L15.998 3.7135L16.7115 3L20 6.2885L16.7115 9.577L15.998 8.8885L18.0538 6.7885H16.1923C15.2179 6.7885 14.391 7.12825 13.7115 7.80775C13.032 8.48725 12.6923 9.31417 12.6923 10.2885V14C12.6923 15.05 12.3294 15.9542 11.6037 16.7125C10.8782 17.4708 9.99242 17.8942 8.94625 17.9827C8.83592 18.5737 8.55033 19.0577 8.0895 19.4345C7.6285 19.8115 7.09867 20 6.5 20ZM4.6885 8.577L4 7.8885L5.575 6.2885L4 4.7135L4.6885 4L6.2885 5.6L7.8635 4L8.577 4.7135L6.977 6.2885L8.577 7.8885L7.8635 8.577L6.2885 7.002L4.6885 8.577Z"
        fill={color}
      />
    </g>
  </svg>
);

export const BillingIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4442_13004"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4442_13004)">
        <path
          d="M6.50007 17V9H7.50007V17H6.50007ZM11.5001 17V9H12.5001V17H11.5001ZM3.53857 20V19H20.4616V20H3.53857ZM16.5001 17V9H17.5001V17H16.5001ZM3.53857 7V6.15375L12.0001 2.1155L20.4616 6.15375V7H3.53857ZM6.18082 6H17.8193L12.0001 3.25L6.18082 6Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const ClockIcon = ({
  size = 24, // default size is 24x24
  color = "#080425", // default fill color
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24" // keep the original coordinate system
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 21C10.891 21 9.85159 20.7913 8.88175 20.374C7.91192 19.9567 7.0645 19.3855 6.3395 18.6605C5.6145 17.9355 5.04334 17.0881 4.626 16.1183C4.20867 15.1484 4 14.109 4 13C4 11.891 4.20867 10.8516 4.626 9.88175C5.04334 8.91192 5.6145 8.0645 6.3395 7.3395C7.0645 6.6145 7.91192 6.04333 8.88175 5.626C9.85159 5.20867 10.891 5 12 5C13.109 5 14.1484 5.20867 15.1183 5.626C16.0881 6.04333 16.9355 6.6145 17.6605 7.3395C18.3855 8.0645 18.9567 8.91192 19.374 9.88175C19.7913 10.8516 20 11.891 20 13C20 14.109 19.7913 15.1484 19.374 16.1183C18.9567 17.0881 18.3855 17.9355 17.6605 18.6605C16.9355 19.3855 16.0881 19.9567 15.1183 20.374C14.1484 20.7913 13.109 21 12 21ZM15.1463 16.8538L15.8538 16.1463L12.5 12.7923V8H11.5V13.2078L15.1463 16.8538ZM5.90775 3.427L6.6155 4.1345L3.1345 7.6155L2.427 6.90775L5.90775 3.427ZM18.0923 3.427L21.573 6.90775L20.8655 7.6155L17.3845 4.1345L18.0923 3.427ZM12 20C13.9372 20 15.5882 19.3177 16.953 17.953C18.3177 16.5882 19 14.9372 19 13C19 11.0628 18.3177 9.41184 16.953 8.047C15.5882 6.68234 13.9372 6 12 6C10.0628 6 8.41184 6.68234 7.047 8.047C5.68234 9.41184 5 11.0628 5 13C5 14.9372 5.68234 16.5882 7.047 17.953C8.41184 19.3177 10.0628 20 12 20Z"
        fill={color}
      />
    </svg>
  );
};

export const UpwardIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3169_8842"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#fff" />
      </mask>
      <g mask="url(#mask0_3169_8842)">
        <path
          d="M11.9999 10.1076L7.39989 14.7076L6.69214 13.9999L11.9999 8.69214L17.3076 13.9999L16.5999 14.7076L11.9999 10.1076Z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export const DownwardIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3169_8833"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#fff" />
      </mask>
      <g mask="url(#mask0_3169_8833)">
        <path
          d="M11.9999 14.702L6.69214 9.39427L7.39989 8.68652L11.9999 13.2808L16.5999 8.68652L17.3076 9.39427L11.9999 14.702Z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export const RevenueIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3810_13343"
        maskUnits="userSpaceOnUse"
        x="3"
        y="3"
        width="18"
        height="18"
      >
        <rect x="3" y="3" width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3810_13343)">
        <path
          d="M5.25 18V17.25H18.75V18H5.25ZM6 15.9231V12H7.5V15.9231H6ZM9.49031 15.9231V8.25H10.9903V15.9231H9.49031ZM12.9953 15.9231V10.5H14.4953V15.9231H12.9953ZM16.5 15.9231V6H18V15.9231H16.5Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const UtilizationDashboardIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4129_7084"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4129_7084)">
        <path
          d="M9.173 21.6943C8.40633 21.6943 7.73492 21.4622 7.15875 20.9981C6.58242 20.5341 6.18525 19.9392 5.96725 19.2136C5.76475 19.5507 5.485 19.8087 5.128 19.9876C4.77083 20.1664 4.39483 20.2558 4 20.2558C3.30383 20.2558 2.71317 20.0127 2.228 19.5266C1.74267 19.0406 1.5 18.4503 1.5 17.7558C1.5 17.1417 1.71408 16.5824 2.14225 16.0781C2.57042 15.5736 3.11083 15.3181 3.7635 15.3116C3.4275 15.0039 3.16175 14.6337 2.96625 14.2011C2.77075 13.7684 2.673 13.3181 2.673 12.8501C2.673 12.2952 2.80858 11.7752 3.07975 11.2898C3.35092 10.8043 3.73075 10.4039 4.21925 10.0886C4.26475 10.2361 4.32608 10.3937 4.40325 10.5616C4.48058 10.7296 4.55967 10.8809 4.6405 11.0156C4.33017 11.2501 4.0955 11.5297 3.9365 11.8543C3.7775 12.1788 3.698 12.5191 3.698 12.8751C3.698 13.9109 4.08133 14.5788 4.848 14.8788C5.61467 15.1788 6.40383 15.4083 7.2155 15.5673L7.4405 15.9636C7.25717 16.4969 7.10842 16.9478 6.99425 17.3163C6.88008 17.685 6.823 18.0257 6.823 18.3386C6.823 18.9616 7.04875 19.5067 7.50025 19.9741C7.95175 20.4414 8.50292 20.6751 9.15375 20.6751C9.86408 20.6751 10.4468 20.4077 10.902 19.8731C11.357 19.3386 11.7307 18.704 12.023 17.9693C12.3153 17.2347 12.542 16.4789 12.703 15.7021C12.8638 14.9251 12.9987 14.2898 13.1077 13.7963L14.0962 14.0713C13.9591 14.7315 13.7949 15.5001 13.6038 16.3771C13.4128 17.2539 13.1407 18.085 12.7875 18.8703C12.4343 19.6555 11.9709 20.3225 11.3973 20.8713C10.8234 21.42 10.082 21.6943 9.173 21.6943ZM4 19.2558C4.4115 19.2558 4.76442 19.1087 5.05875 18.8146C5.35292 18.5202 5.5 18.1673 5.5 17.7558C5.5 17.3443 5.35292 16.9914 5.05875 16.6971C4.76442 16.4029 4.4115 16.2558 4 16.2558C3.5885 16.2558 3.23558 16.4029 2.94125 16.6971C2.64708 16.9914 2.5 17.3443 2.5 17.7558C2.5 18.1673 2.64708 18.5202 2.94125 18.8146C3.23558 19.1087 3.5885 19.2558 4 19.2558ZM10.0808 15.1328C9.40392 14.5263 8.785 13.9593 8.224 13.4318C7.66317 12.9043 7.17858 12.387 6.77025 11.8798C6.36192 11.3728 6.04817 10.8658 5.829 10.3588C5.60967 9.85165 5.5 9.32374 5.5 8.77507C5.5 7.8324 5.82267 7.0384 6.468 6.39307C7.11333 5.74774 7.90733 5.42507 8.85 5.42507C9.032 5.42507 9.19608 5.43565 9.34225 5.45682C9.48842 5.47799 9.62692 5.50782 9.75775 5.54632C9.67825 5.39249 9.61542 5.23424 9.56925 5.07157C9.52308 4.90907 9.5 4.7384 9.5 4.55957C9.5 3.86524 9.74283 3.27499 10.2285 2.78882C10.7142 2.30265 11.3039 2.05957 11.9978 2.05957C12.6916 2.05957 13.2821 2.30265 13.7693 2.78882C14.2564 3.27499 14.5 3.86524 14.5 4.55957C14.5 4.7429 14.4769 4.91374 14.4307 5.07207C14.3846 5.2304 14.3218 5.38657 14.2423 5.54057C14.3731 5.50207 14.5116 5.47315 14.6578 5.45382C14.8039 5.43465 14.968 5.42507 15.15 5.42507C15.9063 5.42507 16.5673 5.64015 17.1328 6.07032C17.6981 6.50049 18.0859 7.04949 18.2962 7.71732C18.1391 7.69299 17.9623 7.68082 17.7658 7.68082C17.5694 7.68082 17.3898 7.69107 17.227 7.71157C17.0462 7.32824 16.7728 7.01799 16.4068 6.78082C16.0408 6.54365 15.6247 6.42507 15.1585 6.42507C14.531 6.42507 14.0323 6.58632 13.6625 6.90882C13.2927 7.23115 12.8116 7.73657 12.2192 8.42507H11.7558C11.1468 7.71607 10.6573 7.20549 10.2875 6.89332C9.91767 6.58115 9.4385 6.42507 8.85 6.42507C8.1725 6.42507 7.6115 6.6474 7.167 7.09207C6.72233 7.53657 6.5 8.09757 6.5 8.77507C6.5 9.16257 6.59875 9.56265 6.79625 9.97532C6.99358 10.388 7.2775 10.8235 7.648 11.2818C8.01867 11.7402 8.46808 12.2277 8.99625 12.7443C9.52442 13.261 10.1237 13.8193 10.7942 14.4193L10.0808 15.1328ZM12 6.05957C12.4115 6.05957 12.7644 5.91249 13.0587 5.61832C13.3529 5.32415 13.5 4.97124 13.5 4.55957C13.5 4.14807 13.3529 3.79524 13.0587 3.50107C12.7644 3.20674 12.4115 3.05957 12 3.05957C11.5885 3.05957 11.2356 3.20674 10.9412 3.50107C10.6471 3.79524 10.5 4.14807 10.5 4.55957C10.5 4.97124 10.6471 5.32415 10.9412 5.61832C11.2356 5.91249 11.5885 6.05957 12 6.05957ZM14.7635 21.7136C14.5262 21.7136 14.2916 21.6882 14.0598 21.6373C13.8279 21.5867 13.6042 21.5063 13.3885 21.3963C13.4812 21.2765 13.5738 21.1352 13.6665 20.9726C13.7592 20.8099 13.8434 20.6601 13.9193 20.5231C14.0673 20.5846 14.2153 20.6285 14.3635 20.6548C14.5115 20.6812 14.6596 20.6943 14.8077 20.6943C15.4564 20.6943 16.0112 20.4612 16.472 19.9951C16.933 19.5291 17.1635 18.975 17.1635 18.3328C17.1635 18.02 17.1064 17.6825 16.9923 17.3203C16.8783 16.9582 16.7296 16.5104 16.5462 15.9771L16.7905 15.5808C17.6187 15.4218 18.4119 15.1892 19.1702 14.8828C19.9286 14.5763 20.3078 13.9052 20.3078 12.8693C20.3078 12.0617 20.0234 11.4629 19.4548 11.0731C18.8862 10.6834 18.2462 10.4886 17.5345 10.4886C16.8625 10.4886 16.0785 10.6027 15.1825 10.8308C14.2865 11.059 13.2519 11.3686 12.0787 11.7596L11.8038 10.7713C12.9499 10.4058 13.9817 10.0942 14.899 9.83657C15.8162 9.5789 16.6582 9.45007 17.425 9.45007C18.434 9.45007 19.3333 9.7469 20.123 10.3406C20.9128 10.9341 21.3078 11.777 21.3078 12.8693C21.3078 13.3318 21.2132 13.7712 21.024 14.1873C20.835 14.6035 20.5725 14.9782 20.2365 15.3116C20.8892 15.3309 21.4296 15.5864 21.8577 16.0781C22.2859 16.5697 22.5 17.129 22.5 17.7558C22.5 18.4353 22.2573 19.0219 21.772 19.5156C21.2868 20.0091 20.6962 20.2558 20 20.2558C19.6052 20.2558 19.2292 20.1664 18.872 19.9876C18.515 19.8087 18.2353 19.5507 18.0328 19.2136C17.8148 19.9392 17.4112 20.5373 16.822 21.0078C16.233 21.4783 15.5468 21.7136 14.7635 21.7136ZM20.025 19.2558C20.4365 19.2558 20.7852 19.1087 21.0712 18.8146C21.3571 18.5202 21.5 18.1673 21.5 17.7558C21.5 17.3443 21.3529 16.9872 21.0588 16.6846C20.7644 16.3821 20.4115 16.2308 20 16.2308C19.5885 16.2308 19.2356 16.3779 18.9413 16.6721C18.6471 16.9664 18.5 17.3193 18.5 17.7308C18.5 18.1423 18.6513 18.4994 18.9538 18.8021C19.2564 19.1046 19.6135 19.2558 20.025 19.2558Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const CompaniesIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3676_13690"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3676_13690)">
        <path
          d="M2.73071 20.1538V3.15381H11.7307V7.15381H21.2692V20.1538H2.73071ZM3.73071 19.1538H10.7307V16.1538H3.73071V19.1538ZM3.73071 15.1538H10.7307V12.1538H3.73071V15.1538ZM3.73071 11.1538H10.7307V8.15381H3.73071V11.1538ZM3.73071 7.15381H10.7307V4.15381H3.73071V7.15381ZM11.7307 19.1538H20.2692V8.15381H11.7307V19.1538ZM14.1155 12.1538V11.1538H17.5V12.1538H14.1155ZM14.1155 16.1538V15.1538H17.5V16.1538H14.1155Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const ContactListIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4035_7012"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4035_7012)">
        <path
          d="M12 21C10.7577 21 9.58867 20.7638 8.493 20.2915C7.3975 19.8192 6.4445 19.1782 5.634 18.3685C4.8235 17.5588 4.18192 16.6067 3.70925 15.512C3.23642 14.4175 3 13.2479 3 12.0033C3 10.7587 3.23617 9.58867 3.7085 8.493C4.18083 7.3975 4.82183 6.4445 5.6315 5.634C6.44117 4.8235 7.39333 4.18192 8.488 3.70925C9.5825 3.23642 10.7521 3 11.9967 3C13.2413 3 14.4113 3.23625 15.507 3.70875C16.6025 4.18125 17.5555 4.8225 18.366 5.6325C19.1765 6.4425 19.8181 7.395 20.2908 8.49C20.7636 9.585 21 10.755 21 12V12.9885C21 13.8308 20.7108 14.5433 20.1322 15.126C19.5536 15.7087 18.8428 16 18 16C17.4038 16 16.8603 15.8365 16.3693 15.5095C15.8783 15.1827 15.5154 14.7474 15.2807 14.2037C14.8999 14.7512 14.4246 15.1875 13.8548 15.5125C13.2849 15.8375 12.6667 16 12 16C10.8858 16 9.94067 15.6118 9.1645 14.8355C8.38817 14.0593 8 13.1142 8 12C8 10.8858 8.38817 9.94067 9.1645 9.1645C9.94067 8.38817 10.8858 8 12 8C13.1142 8 14.0593 8.38817 14.8355 9.1645C15.6118 9.94067 16 10.8858 16 12V12.9885C16 13.5372 16.1962 14.0096 16.5885 14.4058C16.9808 14.8019 17.4513 15 18 15C18.5487 15 19.0192 14.8019 19.4115 14.4058C19.8038 14.0096 20 13.5372 20 12.9885V12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20H17V21H12ZM12 15C12.8333 15 13.5417 14.7083 14.125 14.125C14.7083 13.5417 15 12.8333 15 12C15 11.1667 14.7083 10.4583 14.125 9.875C13.5417 9.29167 12.8333 9 12 9C11.1667 9 10.4583 9.29167 9.875 9.875C9.29167 10.4583 9 11.1667 9 12C9 12.8333 9.29167 13.5417 9.875 14.125C10.4583 14.7083 11.1667 15 12 15Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const EncircledPlusIcon = ({ color = "#080425" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3169_9013"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3169_9013)">
        <path
          d="M11.5 16.5H12.5V12.5H16.5V11.5H12.5V7.5H11.5V11.5H7.5V12.5H11.5V16.5ZM12.0033 21C10.7587 21 9.58867 20.7638 8.493 20.2915C7.3975 19.8192 6.4445 19.1782 5.634 18.3685C4.8235 17.5588 4.18192 16.6067 3.70925 15.512C3.23642 14.4175 3 13.2479 3 12.0033C3 10.7587 3.23617 9.58867 3.7085 8.493C4.18083 7.3975 4.82183 6.4445 5.6315 5.634C6.44117 4.8235 7.39333 4.18192 8.488 3.70925C9.5825 3.23642 10.7521 3 11.9967 3C13.2413 3 14.4113 3.23617 15.507 3.7085C16.6025 4.18083 17.5555 4.82183 18.366 5.6315C19.1765 6.44117 19.8181 7.39333 20.2908 8.488C20.7636 9.5825 21 10.7521 21 11.9967C21 13.2413 20.7638 14.4113 20.2915 15.507C19.8192 16.6025 19.1782 17.5555 18.3685 18.366C17.5588 19.1765 16.6067 19.8181 15.512 20.2908C14.4175 20.7636 13.2479 21 12.0033 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const ProjectGroupIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="23" height="23" stroke="#080425" />
      <mask
        id="mask0_3689_18970"
        maskUnits="userSpaceOnUse"
        x="3"
        y="3"
        width="18"
        height="18"
      >
        <rect x="3" y="3" width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3689_18970)">
        <path
          d="M15.0836 18L14.5672 17.4836L15.7485 16.2836L14.5672 15.1024L15.0836 14.5673L16.2836 15.7673L17.4649 14.5673L18 15.1024L16.8 16.2836L18 17.4836L17.4649 18L16.2836 16.8188L15.0836 18ZM7.875 17.25C8.18362 17.25 8.44831 17.1397 8.66906 16.9191C8.88969 16.6983 9 16.4336 9 16.125C9 15.8164 8.88969 15.5517 8.66906 15.3309C8.44831 15.1103 8.18362 15 7.875 15C7.56638 15 7.30169 15.1103 7.08094 15.3309C6.86031 15.5517 6.75 15.8164 6.75 16.125C6.75 16.4336 6.86031 16.6983 7.08094 16.9191C7.30169 17.1397 7.56638 17.25 7.875 17.25ZM7.875 18C7.35575 18 6.91344 17.8173 6.54806 17.4519C6.18269 17.0866 6 16.6442 6 16.125C6 15.6058 6.18269 15.1634 6.54806 14.7981C6.91344 14.4327 7.35575 14.25 7.875 14.25C8.31825 14.25 8.71125 14.3878 9.054 14.6632C9.39687 14.9388 9.6125 15.2952 9.70088 15.7327C10.2846 15.6817 10.7753 15.4418 11.1728 15.0129C11.5704 14.5841 11.7692 14.0798 11.7692 13.5V10.7164C11.7692 9.78462 12.0988 8.98919 12.7579 8.33006C13.417 7.67094 14.2124 7.34137 15.1442 7.34137H16.5548L14.9985 5.78512L15.5336 5.25L18 7.71637L15.5336 10.1828L14.9985 9.66637L16.5403 8.09137H15.1442C14.4134 8.09137 13.7933 8.34619 13.2836 8.85581C12.774 9.36544 12.5192 9.98562 12.5192 10.7164V13.5C12.5192 14.2875 12.2471 14.9656 11.7028 15.5344C11.1587 16.1031 10.4943 16.4207 9.70969 16.4871C9.62694 16.9303 9.41275 17.2933 9.06712 17.5759C8.72137 17.8586 8.324 18 7.875 18ZM6.51637 9.43275L6 8.91637L7.18125 7.71637L6 6.53512L6.51637 6L7.71637 7.2L8.89763 6L9.43275 6.53512L8.23275 7.71637L9.43275 8.91637L8.89763 9.43275L7.71637 8.2515L6.51637 9.43275Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const InfoIconSvg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3671_11076"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3671_11076)">
        <path
          d="M11.5 16.5H12.5V11H11.5V16.5ZM12 9.577C12.1743 9.577 12.3205 9.518 12.4385 9.4C12.5565 9.282 12.6155 9.13583 12.6155 8.9615C12.6155 8.78717 12.5565 8.641 12.4385 8.523C12.3205 8.40517 12.1743 8.34625 12 8.34625C11.8257 8.34625 11.6795 8.40517 11.5615 8.523C11.4435 8.641 11.3845 8.78717 11.3845 8.9615C11.3845 9.13583 11.4435 9.282 11.5615 9.4C11.6795 9.518 11.8257 9.577 12 9.577ZM12.0033 21C10.7587 21 9.58867 20.7638 8.493 20.2915C7.3975 19.8192 6.4445 19.1782 5.634 18.3685C4.8235 17.5588 4.18192 16.6067 3.70925 15.512C3.23642 14.4175 3 13.2479 3 12.0033C3 10.7587 3.23617 9.58867 3.7085 8.493C4.18083 7.3975 4.82183 6.4445 5.6315 5.634C6.44117 4.8235 7.39333 4.18192 8.488 3.70925C9.5825 3.23642 10.7521 3 11.9967 3C13.2413 3 14.4113 3.23617 15.507 3.7085C16.6025 4.18083 17.5555 4.82183 18.366 5.6315C19.1765 6.44117 19.8181 7.39333 20.2908 8.488C20.7636 9.5825 21 10.7521 21 11.9967C21 13.2413 20.7638 14.4113 20.2915 15.507C19.8192 16.6025 19.1782 17.5555 18.3685 18.366C17.5588 19.1765 16.6067 19.8181 15.512 20.2908C14.4175 20.7636 13.2479 21 12.0033 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const MinusSvg = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" fill="#080425" />
      <path d="M4 9V8H12V9H4Z" fill="white" />
    </svg>
  );
};

export const FlowSvg = () => {
  return (
    <svg
      width="54"
      height="18"
      viewBox="0 0 54 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 17.7273V0.27272H11.5568V3.31533H3.69034V7.47442H10.7898V10.517H3.69034V17.7273H0Z"
        fill="#080425"
      />
      <path
        d="M17.1873 0.27272V17.7273H13.5566V0.27272H17.1873Z"
        fill="#080425"
      />
      <path
        d="M25.6307 17.7273C24.3068 17.7273 23.1619 17.446 22.196 16.8835C21.2358 16.3153 20.4943 15.5256 19.9716 14.5142C19.4489 13.4972 19.1875 12.3182 19.1875 10.9773C19.1875 9.62499 19.4489 8.44318 19.9716 7.43181C20.4943 6.41477 21.2358 5.62499 22.196 5.06249C23.1619 4.49431 24.3068 4.21022 25.6307 4.21022C26.9545 4.21022 28.0966 4.49431 29.0568 5.06249C30.0227 5.62499 30.767 6.41477 31.2898 7.43181C31.8125 8.44318 32.0739 9.62499 32.0739 10.9773C32.0739 12.3182 31.8125 13.4972 31.2898 14.5142C30.767 15.5256 30.0227 16.3153 29.0568 16.8835C28.0966 17.446 26.9545 17.7273 25.6307 17.7273ZM25.6477 14.9148C26.25 14.9148 26.7528 14.7443 27.1563 14.4034C27.5597 14.0568 27.8636 13.5852 28.0682 12.9886C28.2784 12.392 28.3835 11.7131 28.3835 10.9517C28.3835 10.1903 28.2784 9.51136 28.0682 8.91477C27.8636 8.31818 27.5597 7.84658 27.1563 7.49999C26.7528 7.1534 26.25 6.98011 25.6477 6.98011C25.0398 6.98011 24.5284 7.1534 24.1136 7.49999C23.7045 7.84658 23.3949 8.31818 23.1847 8.91477C22.9801 9.51136 22.8778 10.1903 22.8778 10.9517C22.8778 11.7131 22.9801 12.392 23.1847 12.9886C23.3949 13.5852 23.7045 14.0568 24.1136 14.4034C24.5284 14.7443 25.0398 14.9148 25.6477 14.9148Z"
        fill="#080425"
      />
      <path
        d="M37.6367 17.7273L34.0742 4.63637H37.7475L39.7759 13.4318H39.8952L42.0089 4.63637H45.614L47.7617 13.3807H47.8725L49.8668 4.63637H53.5316L49.9776 17.7273H46.1339L43.8839 9.49432H43.7219L41.4719 17.7273H37.6367Z"
        fill="#080425"
      />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3904_2647"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3904_2647)">
        <path
          d="M5 19H6.098L16.7962 8.302L15.698 7.20375L5 17.902V19ZM4 20V17.4808L17.1807 4.2865C17.2832 4.19517 17.3963 4.12458 17.52 4.07475C17.6438 4.02492 17.7729 4 17.9072 4C18.0416 4 18.1717 4.02117 18.2977 4.0635C18.4236 4.10583 18.5398 4.18208 18.6462 4.29225L19.7135 5.3655C19.8237 5.47183 19.899 5.5885 19.9395 5.7155C19.9798 5.84267 20 5.96975 20 6.09675C20 6.23225 19.9772 6.36192 19.9315 6.48575C19.8858 6.60942 19.8132 6.7225 19.7135 6.825L6.51925 20H4ZM16.2375 7.7625L15.698 7.20375L16.7962 8.302L16.2375 7.7625Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3796_9079"
        maskUnits="userSpaceOnUse"
        x="3"
        y="3"
        width="18"
        height="18"
      >
        <rect x="3" y="3" width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3796_9079)">
        <path
          d="M12 14.6827L9.34612 12.0289L9.87694 11.4894L11.625 13.2375V6.75H12.375V13.2375L14.1231 11.4894L14.6539 12.0289L12 14.6827ZM7.96162 17.25C7.61637 17.25 7.32812 17.1344 7.09688 16.9031C6.86563 16.6719 6.75 16.3836 6.75 16.0384V14.2211H7.5V16.0384C7.5 16.1539 7.54806 16.2597 7.64419 16.3558C7.74031 16.4519 7.84612 16.5 7.96162 16.5H16.0384C16.1539 16.5 16.2597 16.4519 16.3558 16.3558C16.4519 16.2597 16.5 16.1539 16.5 16.0384V14.2211H17.25V16.0384C17.25 16.3836 17.1344 16.6719 16.9031 16.9031C16.6719 17.1344 16.3836 17.25 16.0384 17.25H7.96162Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const UpDownArrowSvg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3169_8824"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3169_8824)">
        <path
          d="M11.9999 21.3076L6.69214 15.9999L7.40564 15.2864L11.9999 19.8421L16.5941 15.2864L17.3076 15.9999L11.9999 21.3076ZM7.41139 8.70764L6.69214 7.99989L11.9999 2.69214L17.3076 7.99989L16.5884 8.70764L11.9999 4.15764L7.41139 8.70764Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const ProfileIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3962_15530"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3962_15530)">
        <path
          d="M6.19625 17.4845C7.04625 16.873 7.94817 16.3894 8.902 16.0337C9.85583 15.6779 10.8885 15.5 12 15.5C13.1115 15.5 14.1442 15.6779 15.098 16.0337C16.0518 16.3894 16.9538 16.873 17.8038 17.4845C18.4641 16.8012 18.9952 15.9942 19.397 15.0635C19.799 14.1327 20 13.1115 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 13.1115 4.201 14.1327 4.603 15.0635C5.00483 15.9942 5.53592 16.8012 6.19625 17.4845ZM12.0005 12.5C11.1578 12.5 10.4471 12.2108 9.86825 11.6323C9.28942 11.0538 9 10.3432 9 9.5005C9 8.65783 9.28925 7.94708 9.86775 7.36825C10.4462 6.78942 11.1568 6.5 11.9995 6.5C12.8422 6.5 13.5529 6.78925 14.1318 7.36775C14.7106 7.94625 15 8.65683 15 9.4995C15 10.3422 14.7107 11.0529 14.1322 11.6318C13.5538 12.2106 12.8432 12.5 12.0005 12.5ZM12 21C10.7448 21 9.56983 20.7663 8.475 20.299C7.38017 19.8317 6.42758 19.1929 5.61725 18.3828C4.80708 17.5724 4.16833 16.6198 3.701 15.525C3.23367 14.4302 3 13.2552 3 12C3 10.7448 3.23367 9.56983 3.701 8.475C4.16833 7.38017 4.80708 6.42758 5.61725 5.61725C6.42758 4.80708 7.38017 4.16833 8.475 3.701C9.56983 3.23367 10.7448 3 12 3C13.2552 3 14.4302 3.23367 15.525 3.701C16.6198 4.16833 17.5724 4.80708 18.3828 5.61725C19.1929 6.42758 19.8317 7.38017 20.299 8.475C20.7663 9.56983 21 10.7448 21 12C21 13.2552 20.7663 14.4302 20.299 15.525C19.8317 16.6198 19.1929 17.5724 18.3828 18.3828C17.5724 19.1929 16.6198 19.8317 15.525 20.299C14.4302 20.7663 13.2552 21 12 21ZM12 20C12.9218 20 13.8289 19.8388 14.7212 19.5163C15.6134 19.1939 16.3845 18.7526 17.0345 18.1923C16.3845 17.6704 15.6326 17.2579 14.7788 16.9548C13.9249 16.6516 12.9987 16.5 12 16.5C11.0013 16.5 10.0718 16.6484 9.2115 16.9453C8.35133 17.2421 7.60267 17.6578 6.9655 18.1923C7.6155 18.7526 8.38658 19.1939 9.27875 19.5163C10.1711 19.8388 11.0782 20 12 20ZM12 11.5C12.5615 11.5 13.0352 11.3071 13.4212 10.9212C13.8071 10.5352 14 10.0615 14 9.5C14 8.9385 13.8071 8.46475 13.4212 8.07875C13.0352 7.69292 12.5615 7.5 12 7.5C11.4385 7.5 10.9648 7.69292 10.5788 8.07875C10.1929 8.46475 10 8.9385 10 9.5C10 10.0615 10.1929 10.5352 10.5788 10.9212C10.9648 11.3071 11.4385 11.5 12 11.5Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const LogoutIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3962_15427"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3962_15427)">
        <path
          d="M20.5923 12.5H9.15375V11.5H20.5923L18.5038 9.4115L19.2115 8.69225L22.5193 12L19.2115 15.3077L18.5038 14.5885L20.5923 12.5ZM15.4038 8.73075V5.6155C15.4038 5.436 15.3461 5.2885 15.2308 5.173C15.1154 5.05767 14.968 5 14.7885 5H5.6155C5.436 5 5.2885 5.05767 5.173 5.173C5.05767 5.2885 5 5.436 5 5.6155V18.3845C5 18.564 5.05767 18.7115 5.173 18.827C5.2885 18.9423 5.436 19 5.6155 19H14.7885C14.968 19 15.1154 18.9423 15.2308 18.827C15.3461 18.7115 15.4038 18.564 15.4038 18.3845V15.2692H16.4038V18.3845C16.4038 18.832 16.2464 19.2132 15.9318 19.528C15.6169 19.8427 15.2358 20 14.7885 20H5.6155C5.168 20 4.78683 19.8427 4.472 19.528C4.15733 19.2132 4 18.832 4 18.3845V5.6155C4 5.168 4.15733 4.78683 4.472 4.472C4.78683 4.15733 5.168 4 5.6155 4H14.7885C15.2358 4 15.6169 4.15733 15.9318 4.472C16.2464 4.78683 16.4038 5.168 16.4038 5.6155V8.73075H15.4038Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const SaveIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3945_8959"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="20"
        height="20"
      >
        <rect x="2" y="2" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3945_8959)">
        <path
          d="M18.1666 8.35242V16.987C18.1666 17.3248 18.0544 17.6058 17.8301 17.8301C17.6058 18.0544 17.3248 18.1666 16.987 18.1666H7.01284C6.67506 18.1666 6.39402 18.0544 6.16971 17.8301C5.9454 17.6058 5.83325 17.3248 5.83325 16.987V7.01284C5.83325 6.67506 5.9454 6.39402 6.16971 6.16971C6.39402 5.94541 6.67506 5.83325 7.01284 5.83325H15.6474L18.1666 8.35242ZM17.4999 8.62492L15.3749 6.49992H7.01284C6.86325 6.49992 6.74034 6.54797 6.64409 6.64408C6.54797 6.74033 6.49992 6.86325 6.49992 7.01284V16.987C6.49992 17.1366 6.54797 17.2595 6.64409 17.3558C6.74034 17.4519 6.86325 17.4999 7.01284 17.4999H16.987C17.1366 17.4999 17.2595 17.4519 17.3558 17.3558C17.4519 17.2595 17.4999 17.1366 17.4999 16.987V8.62492ZM11.9999 15.532C12.3899 15.532 12.7235 15.3934 13.0008 15.1162C13.278 14.8389 13.4166 14.5053 13.4166 14.1153C13.4166 13.7253 13.278 13.3917 13.0008 13.1145C12.7235 12.8373 12.3899 12.6987 11.9999 12.6987C11.6099 12.6987 11.2763 12.8373 10.9991 13.1145C10.7219 13.3917 10.5833 13.7253 10.5833 14.1153C10.5833 14.5053 10.7219 14.8389 10.9991 15.1162C11.2763 15.3934 11.6099 15.532 11.9999 15.532ZM8.14096 10.3076H13.8268V8.14096H8.14096V10.3076Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const EnlargeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4554_9603"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4554_9603)">
        <path
          d="M4 20V13H5V18.3115L18.3115 5H13V4H20V11H19V5.6885L5.6885 19H11V20H4Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};

export const CalendarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_7072_9948"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7072_9948)">
        <path
          d="M5.6155 20.9998C5.15517 20.9998 4.77083 20.8456 4.4625 20.5373C4.15417 20.229 4 19.8446 4 19.3843V6.61529C4 6.15496 4.15417 5.77063 4.4625 5.46229C4.77083 5.15396 5.15517 4.99979 5.6155 4.99979H7.3845V2.76904H8.4615V4.99979H15.6155V2.76904H16.6155V4.99979H18.3845C18.8448 4.99979 19.2292 5.15396 19.5375 5.46229C19.8458 5.77063 20 6.15496 20 6.61529V19.3843C20 19.8446 19.8458 20.229 19.5375 20.5373C19.2292 20.8456 18.8448 20.9998 18.3845 20.9998H5.6155ZM5.6155 19.9998H18.3845C18.5385 19.9998 18.6796 19.9357 18.8077 19.8075C18.9359 19.6794 19 19.5383 19 19.3843V10.6153H5V19.3843C5 19.5383 5.06408 19.6794 5.19225 19.8075C5.32042 19.9357 5.4615 19.9998 5.6155 19.9998ZM5 9.61504H19V6.61529C19 6.46129 18.9359 6.32021 18.8077 6.19204C18.6796 6.06388 18.5385 5.99979 18.3845 5.99979H5.6155C5.4615 5.99979 5.32042 6.06388 5.19225 6.19204C5.06408 6.32021 5 6.46129 5 6.61529V9.61504ZM12 14.1535C11.7937 14.1535 11.6138 14.077 11.4605 13.9238C11.3073 13.7706 11.2308 13.5908 11.2308 13.3843C11.2308 13.178 11.3073 12.9982 11.4605 12.845C11.6138 12.6919 11.7937 12.6153 12 12.6153C12.2063 12.6153 12.3862 12.6919 12.5395 12.845C12.6927 12.9982 12.7692 13.178 12.7692 13.3843C12.7692 13.5908 12.6927 13.7706 12.5395 13.9238C12.3862 14.077 12.2063 14.1535 12 14.1535ZM8 14.1535C7.79367 14.1535 7.61383 14.077 7.4605 13.9238C7.30733 13.7706 7.23075 13.5908 7.23075 13.3843C7.23075 13.178 7.30733 12.9982 7.4605 12.845C7.61383 12.6919 7.79367 12.6153 8 12.6153C8.20633 12.6153 8.38617 12.6919 8.5395 12.845C8.69267 12.9982 8.76925 13.178 8.76925 13.3843C8.76925 13.5908 8.69267 13.7706 8.5395 13.9238C8.38617 14.077 8.20633 14.1535 8 14.1535ZM16 14.1535C15.7937 14.1535 15.6138 14.077 15.4605 13.9238C15.3073 13.7706 15.2308 13.5908 15.2308 13.3843C15.2308 13.178 15.3073 12.9982 15.4605 12.845C15.6138 12.6919 15.7937 12.6153 16 12.6153C16.2063 12.6153 16.3862 12.6919 16.5395 12.845C16.6927 12.9982 16.7693 13.178 16.7693 13.3843C16.7693 13.5908 16.6927 13.7706 16.5395 13.9238C16.3862 14.077 16.2063 14.1535 16 14.1535ZM12 17.9998C11.7937 17.9998 11.6138 17.9232 11.4605 17.77C11.3073 17.6169 11.2308 17.437 11.2308 17.2305C11.2308 17.0242 11.3073 16.8444 11.4605 16.691C11.6138 16.5379 11.7937 16.4613 12 16.4613C12.2063 16.4613 12.3862 16.5379 12.5395 16.691C12.6927 16.8444 12.7692 17.0242 12.7692 17.2305C12.7692 17.437 12.6927 17.6169 12.5395 17.77C12.3862 17.9232 12.2063 17.9998 12 17.9998ZM8 17.9998C7.79367 17.9998 7.61383 17.9232 7.4605 17.77C7.30733 17.6169 7.23075 17.437 7.23075 17.2305C7.23075 17.0242 7.30733 16.8444 7.4605 16.691C7.61383 16.5379 7.79367 16.4613 8 16.4613C8.20633 16.4613 8.38617 16.5379 8.5395 16.691C8.69267 16.8444 8.76925 17.0242 8.76925 17.2305C8.76925 17.437 8.69267 17.6169 8.5395 17.77C8.38617 17.9232 8.20633 17.9998 8 17.9998ZM16 17.9998C15.7937 17.9998 15.6138 17.9232 15.4605 17.77C15.3073 17.6169 15.2308 17.437 15.2308 17.2305C15.2308 17.0242 15.3073 16.8444 15.4605 16.691C15.6138 16.5379 15.7937 16.4613 16 16.4613C16.2063 16.4613 16.3862 16.5379 16.5395 16.691C16.6927 16.8444 16.7693 17.0242 16.7693 17.2305C16.7693 17.437 16.6927 17.6169 16.5395 17.77C16.3862 17.9232 16.2063 17.9998 16 17.9998Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const ClockWithPlusIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3169_9163"
        maskUnits="userSpaceOnUse"
        x="0"
        y="-3"
        width="24"
        height="24"
      >
        <rect y="-3" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3169_9163)">
        <path
          d="M11.5 16.073H12.5V13.073H15.5V12.073H12.5V9.073H11.5V12.073H8.5V13.073H11.5V16.073ZM12.001 20.573C10.8913 20.573 9.85159 20.3643 8.88175 19.947C7.91192 19.5297 7.0645 18.9585 6.3395 18.2335C5.6145 17.5085 5.04334 16.6614 4.626 15.6922C4.20867 14.7232 4 13.6838 4 12.574C4 11.4643 4.20867 10.4246 4.626 9.45475C5.04334 8.48492 5.6145 7.6375 6.3395 6.9125C7.0645 6.1875 7.91159 5.61633 8.88075 5.199C9.84975 4.78167 10.8892 4.573 11.999 4.573C13.1087 4.573 14.1484 4.78167 15.1183 5.199C16.0881 5.61633 16.9355 6.1875 17.6605 6.9125C18.3855 7.6375 18.9567 8.48458 19.374 9.45375C19.7913 10.4227 20 11.4622 20 12.572C20 13.6817 19.7913 14.7214 19.374 15.6912C18.9567 16.6611 18.3855 17.5085 17.6605 18.2335C16.9355 18.9585 16.0884 19.5297 15.1193 19.947C14.1503 20.3643 13.1108 20.573 12.001 20.573ZM5.90775 3L6.6155 3.7075L3.1345 7.1885L2.427 6.48075L5.90775 3ZM18.0923 3L21.573 6.48075L20.8655 7.1885L17.3845 3.7075L18.0923 3ZM12 19.573C13.9372 19.573 15.5882 18.8907 16.953 17.526C18.3177 16.1612 19 14.5102 19 12.573C19 10.6358 18.3177 8.98483 16.953 7.62C15.5882 6.25533 13.9372 5.573 12 5.573C10.0628 5.573 8.41184 6.25533 7.047 7.62C5.68234 8.98483 5 10.6358 5 12.573C5 14.5102 5.68234 16.1612 7.047 17.526C8.41184 18.8907 10.0628 19.573 12 19.573Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const DollarIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3710_7005"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3710_7005)">
        <path
          d="M8.61489 15.375V13.8491C7.97164 13.7664 7.41901 13.5437 6.95701 13.1812C6.49501 12.8187 6.15151 12.3173 5.92651 11.6769L6.62158 11.3741C6.83795 11.9356 7.13533 12.3678 7.5137 12.6707C7.89208 12.9736 8.40533 13.125 9.05345 13.125C9.62358 13.125 10.1445 12.9829 10.6161 12.6988C11.0877 12.4147 11.3235 11.9567 11.3235 11.325C11.3235 10.7914 11.15 10.3628 10.8028 10.0391C10.4557 9.71563 9.8062 9.401 8.85433 9.09525C7.88508 8.7865 7.20289 8.43381 6.80776 8.03719C6.41251 7.64056 6.21489 7.124 6.21489 6.4875C6.21489 5.79037 6.4822 5.23362 7.01683 4.81725C7.55145 4.401 8.08414 4.176 8.61489 4.14225V2.625H9.36489V4.14225C9.88414 4.19425 10.3301 4.33825 10.7027 4.57425C11.0753 4.81038 11.3842 5.14619 11.6293 5.58169L10.963 5.92219C10.7841 5.59906 10.538 5.3375 10.2246 5.1375C9.91108 4.9375 9.51201 4.8375 9.02739 4.8375C8.44851 4.8375 7.96008 4.99062 7.56208 5.29688C7.16395 5.60313 6.96489 6 6.96489 6.4875C6.96489 6.94812 7.12839 7.32119 7.45539 7.60669C7.78226 7.89231 8.43701 8.19038 9.41964 8.50088C10.3303 8.78938 11.0003 9.15981 11.4296 9.61219C11.8589 10.0647 12.0735 10.6327 12.0735 11.3164C12.0735 12.0693 11.8086 12.6673 11.2789 13.1106C10.749 13.5538 10.111 13.8029 9.36489 13.8577V15.375H8.61489Z"
          fill="#080425"
        />
      </g>
    </svg>
  );
};

export const DownIconSelect = () => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_3169_8833"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_3169_8833)">
          <path
            d="M11.9999 14.702L6.69214 9.39427L7.39989 8.68652L11.9999 13.2808L16.5999 8.68652L17.3076 9.39427L11.9999 14.702Z"
            fill="#080425"
          />
        </g>
      </svg>
    </div>
  );
};

export const PercentageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M3.327 6.63471C2.54617 6.63471 1.87983 6.35879 1.328 5.80696C0.776 5.25496 0.5 4.58862 0.5 3.80796C0.5 3.02712 0.776 2.36079 1.328 1.80896C1.87983 1.25696 2.54617 0.980957 3.327 0.980957C4.10767 0.980957 4.774 1.25696 5.326 1.80896C5.87783 2.36079 6.15375 3.02712 6.15375 3.80796C6.15375 4.58862 5.87783 5.25496 5.326 5.80696C4.774 6.35879 4.10767 6.63471 3.327 6.63471ZM3.32575 5.63471C3.83292 5.63471 4.26442 5.45721 4.62025 5.10221C4.97592 4.74721 5.15375 4.31612 5.15375 3.80896C5.15375 3.30179 4.97625 2.87037 4.62125 2.51471C4.26625 2.15887 3.83517 1.98096 3.328 1.98096C2.82083 1.98096 2.38942 2.15846 2.03375 2.51346C1.67792 2.86846 1.5 3.29954 1.5 3.80671C1.5 4.31387 1.6775 4.74537 2.0325 5.10121C2.3875 5.45687 2.81858 5.63471 3.32575 5.63471ZM11.6923 15.0002C10.9116 15.0002 10.2452 14.7242 9.69325 14.1722C9.14142 13.6204 8.8655 12.954 8.8655 12.1732C8.8655 11.3925 9.14142 10.7262 9.69325 10.1742C10.2452 9.62237 10.9116 9.34646 11.6923 9.34646C12.4731 9.34646 13.1394 9.62237 13.6913 10.1742C14.2433 10.7262 14.5193 11.3925 14.5193 12.1732C14.5193 12.954 14.2433 13.6204 13.6913 14.1722C13.1394 14.7242 12.4731 15.0002 11.6923 15.0002ZM11.6913 14.0002C12.1984 14.0002 12.6298 13.8227 12.9855 13.4677C13.3413 13.1127 13.5193 12.6816 13.5193 12.1745C13.5193 11.6673 13.3417 11.2358 12.9867 10.88C12.6318 10.5243 12.2007 10.3465 11.6935 10.3465C11.1863 10.3465 10.7548 10.524 10.399 10.879C10.0433 11.234 9.8655 11.665 9.8655 12.1722C9.8655 12.6794 10.043 13.1108 10.398 13.4665C10.753 13.8223 11.1841 14.0002 11.6913 14.0002ZM1.38075 14.808L0.69225 14.1195L13.6385 1.17321L14.327 1.86171L1.38075 14.808Z"
        fill="#080425"
      />
    </svg>
  );
};

export const CustomArticleOutlinedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <mask
      id="mask0_article"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="40"
      height="40"
    >
      <rect width="40" height="40" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_article)">
      <path
        d="M12.4594 27.5062H22.4057V26.0962H12.4594V27.5062ZM12.4594 20.705H27.5403V19.295H12.4594V20.705ZM12.4594 13.9037H27.5403V12.4937H12.4594V13.9037ZM9.10234 33.3333C8.41956 33.3333 7.84289 33.098 7.37234 32.6275C6.90178 32.1569 6.6665 31.5802 6.6665 30.8975V9.10246C6.6665 8.41968 6.90178 7.84301 7.37234 7.37246C7.84289 6.9019 8.41956 6.66663 9.10234 6.66663H30.8973C31.5801 6.66663 32.1568 6.9019 32.6273 7.37246C33.0979 7.84301 33.3332 8.41968 33.3332 9.10246V30.8975C33.3332 31.5802 33.0979 32.1569 32.6273 32.6275C32.1568 33.098 31.5801 33.3333 30.8973 33.3333H9.10234ZM9.10234 31.9229H30.8973C31.1537 31.9229 31.3887 31.8161 31.6023 31.6025C31.816 31.3888 31.9228 31.1538 31.9228 30.8975V9.10246C31.9228 8.84607 31.816 8.61107 31.6023 8.39746C31.3887 8.18385 31.1537 8.07704 30.8973 8.07704H9.10234C8.84595 8.07704 8.61095 8.18385 8.39734 8.39746C8.18373 8.61107 8.07692 8.84607 8.07692 9.10246V30.8975C8.07692 31.1538 8.18373 31.3888 8.39734 31.6025C8.61095 31.8161 8.84595 31.9229 9.10234 31.9229Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>
);

export const MinimizeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4554_9611"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4554_9611)">
        <path
          d="M3.6885 21L3 20.3115L10.3115 13H5V12H12V19H11V13.6885L3.6885 21ZM12 12V5H13V10.3115L20.3115 3L21 3.6885L13.6885 11H19V12H12Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};

export const PlusCircle = ({ className }) => {
  return (
    <svg
      className={`plus-circle ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M12 9V12M12 12V15M12 12H15M12 12H9M21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};

export const Notes = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="clinical_notes">
        <mask
          id="mask0_7826_4409"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect id="Bounding box" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_7826_4409)">
          <path
            id="clinical_notes_2"
            d="M17 15.6345C16.359 15.6345 15.8142 15.4102 15.3655 14.9615C14.9167 14.5128 14.6923 13.968 14.6923 13.327C14.6923 12.686 14.9167 12.1411 15.3655 11.6923C15.8142 11.2436 16.359 11.0193 17 11.0193C17.641 11.0193 18.1858 11.2436 18.6345 11.6923C19.0833 12.1411 19.3077 12.686 19.3077 13.327C19.3077 13.968 19.0833 14.5128 18.6345 14.9615C18.1858 15.4102 17.641 15.6345 17 15.6345ZM17 14.6345C17.3603 14.6345 17.6683 14.5067 17.924 14.251C18.1798 13.9952 18.3077 13.6872 18.3077 13.327C18.3077 12.9667 18.1798 12.6587 17.924 12.403C17.6683 12.1472 17.3603 12.0192 17 12.0192C16.6397 12.0192 16.3317 12.1472 16.076 12.403C15.8202 12.6587 15.6923 12.9667 15.6923 13.327C15.6923 13.6872 15.8202 13.9952 16.076 14.251C16.3317 14.5067 16.6397 14.6345 17 14.6345ZM11.6923 21.5385V19.3307C11.6923 19.1017 11.7469 18.8863 11.8563 18.6845C11.9656 18.4828 12.1187 18.322 12.3155 18.202C12.7785 17.9243 13.2668 17.6941 13.7803 17.5113C14.2939 17.3286 14.8184 17.1934 15.3538 17.1058L17 19.25L18.627 17.1058C19.1685 17.1934 19.6954 17.3286 20.2078 17.5113C20.7201 17.6941 21.2104 17.9243 21.6788 18.202C21.8763 18.3212 22.0273 18.4804 22.1318 18.6798C22.2362 18.8791 22.2949 19.0897 22.3078 19.3115V21.5385H11.6923ZM12.6673 20.5385H16.723L14.9693 18.2345C14.5628 18.3302 14.1675 18.4544 13.7835 18.6072C13.3997 18.7601 13.0276 18.9372 12.6673 19.1385V20.5385ZM17.277 20.5385H21.3078V19.1385C20.9513 18.9333 20.5811 18.7587 20.1973 18.6145C19.8133 18.4702 19.418 18.3499 19.0115 18.2538L17.277 20.5385ZM5.6245 20C5.171 20 4.78683 19.8418 4.472 19.5255C4.15733 19.2092 4 18.8288 4 18.3845V5.6155C4 5.17117 4.15817 4.79083 4.4745 4.4745C4.79083 4.15817 5.17117 4 5.6155 4H18.3845C18.8288 4 19.2092 4.15817 19.5255 4.4745C19.8418 4.79083 20 5.17117 20 5.6155V9.30775C19.8487 9.16675 19.6948 9.03917 19.5385 8.925C19.382 8.81083 19.2025 8.723 19 8.6615V5.6155C19 5.436 18.9423 5.2885 18.827 5.173C18.7115 5.05767 18.564 5 18.3845 5H5.6155C5.436 5 5.2885 5.05767 5.173 5.173C5.05767 5.2885 5 5.436 5 5.6155V18.3845C5 18.564 5.05767 18.7115 5.173 18.827C5.2885 18.9423 5.436 19 5.6155 19H8.95775C8.94625 19.0552 8.93758 19.1103 8.93175 19.1655C8.92592 19.2205 8.923 19.2756 8.923 19.3307V20H5.6245ZM7.5 8.73075H14.923C15.164 8.58975 15.4178 8.48717 15.6845 8.423C15.9512 8.359 16.223 8.31417 16.5 8.2885V7.73075H7.5V8.73075ZM7.5 12.5H12.0192C12.0449 12.3167 12.0792 12.1448 12.122 11.9845C12.165 11.8243 12.2148 11.6628 12.2713 11.5H7.5V12.5ZM7.5 16.2692H10.2963C10.4668 16.1321 10.6433 16.0019 10.826 15.8787C11.0087 15.7557 11.1955 15.6507 11.3865 15.5635V15.2692H7.5V16.2692ZM5 19V5V8.65575V8.25V19Z"
            fill="#1C1B1F"
          />
        </g>
      </g>
    </svg>
  );
};
